import Dexie, { type EntityTable } from 'dexie';

export interface SaveRow {
  id: string;
  schemaVersion: number;
  updatedAtUtc: number;
  payload: unknown;
}

export interface SettingRow {
  id: string;
  updatedAtUtc: number;
  payload: unknown;
}

class GameDatabase extends Dexie {
  saves!: EntityTable<SaveRow, 'id'>;
  settings!: EntityTable<SettingRow, 'id'>;

  public constructor() {
    super('cottage-and-garden');
    this.version(1).stores({
      saves: '&id, updatedAtUtc',
    });
    this.version(2).stores({
      saves: '&id, updatedAtUtc',
      settings: '&id, updatedAtUtc',
    });
  }
}

export const gameDatabase = new GameDatabase();
